import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { SMS_MODULE_URL } from '@shared/helpers/env';

class MessageServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
}

export const MessageService = new MessageServiceClass({
  api_version: 2,
  resource: 'incoming-messages'
});

class NewMessageServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getParts(part_group) {
    return this.http.get('parts', { params: { part_group } });
  }
}

export const NewMessageService = new NewMessageServiceClass({
  api_version: 1,
  resource: 'messages',
  base_url: SMS_MODULE_URL
});
